// Central API helper for the Oracle backend.
const API = process.env.REACT_APP_API_URL || "http://localhost:8002";

async function _fetch(url, opts = {}) {
  const r = await fetch(url, opts);
  const d = await r.json();
  if (!r.ok) throw new Error(d.detail || `Request failed: ${r.status}`);
  return d;
}

export async function fetchTables() {
  const d = await _fetch(`${API}/api/oracle/tables`);
  return d.tables || [];
}

export async function fetchColumns(table) {
  const d = await _fetch(`${API}/api/oracle/columns/${table}`);
  return { measures: d.measures || [], dimensions: d.dimensions || [], role: d.role };
}

export async function fetchDistinct(table, column, limit = 300) {
  const d = await _fetch(`${API}/api/oracle/distinct/${table}/${column}?limit=${limit}`);
  return { values: d.values || [], count: d.count };
}

export async function fetchKPIs() {
  const d = await _fetch(`${API}/api/oracle/kpis`);
  return d.kpis || [];
}

export async function runSingleQuery({ table, dimension, measure, agg = "SUM", limit = 50 }) {
  const d = await _fetch(`${API}/api/oracle/query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ table, dimension, measure, agg, limit }),
  });
  return d; // { success, sql, rows, data: [{label, value}] }
}

export async function runMultiQuery({ factTable, measure, measures, dimensions, agg = "SUM", limit = 100, filters = [] }) {
  const d = await _fetch(`${API}/api/oracle/multi-query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fact_table: factTable,
      measure, measures: measures || [],
      dimensions, agg, limit, filters,
    }),
  });
  return d; // { success, sql, rows, measures:[labels], data: [{label, value, values:[], <label>:v}] }
}

export async function runMultiQueryPivot({ factTable, measure, measures, dimensions, agg = "SUM", limit = 500, filters = [] }) {
  const d = await _fetch(`${API}/api/oracle/multi-query-pivot`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fact_table: factTable,
      measure, measures: measures || [],
      dimensions, agg, limit, filters,
    }),
  });
  return d; // { success, sql, rows, dimension_columns, measure_columns:[], data: [{}] }
}

export async function fetchRoles(connectionId = "oracle_free") {
  const d = await _fetch(`${API}/api/oracle/roles/${connectionId}`);
  return d.tables || [];
}

export async function fetchReachable(table) {
  // tables that can be combined with `table` in a correct (join-valid) report
  try {
    const d = await _fetch(`${API}/api/oracle/reachable/${table}`);
    return d.reachable || [];
  } catch {
    return [];
  }
}

export async function checkGroqStatus() {
  const d = await _fetch(`${API}/api/groq/status`);
  return d; // { configured, message }
}

export async function runNLQuery(question, connectionId = "oracle_free") {
  const d = await _fetch(`${API}/api/groq/nl-query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question, connection_id: connectionId }),
  });
  return d; // { success, question, sql, columns, rows, data }
}
